/* eslint-disable jsx-a11y/anchor-is-valid */

const ParameterValueWidget = ({parameterData}) => {
  return (
    <a href='#' className='card hoverable shadow mb-4'>
      <div className='card-body d-flex flex-column align-items-center justify-content-center text-center'>
        <div className='fw-bold'>Value</div>

        {parameterData?.limit_status == 'N' ? (
          <div className='fw-semibold fs-1 text-success'>
            {Number(parameterData?.current_value).toFixed(2)} {parameterData?.unit}
          </div>
        ) : parameterData?.limit_status == 'O' || parameterData?.limit_status == 'U' ? (
          <div className='fw-semibold fs-1 text-danger'>
            {Number(parameterData?.current_value).toFixed(2)} {parameterData?.unit}
          </div>
        ) : (
          <div className='fw-semibold fs-1'>
            {Number(parameterData?.current_value).toFixed(2)} {parameterData?.unit}
          </div>
        )}
      </div>
    </a>
  )
}
export {ParameterValueWidget}
